import Component from '../colorz/Component';

export default class Timer extends Component {
	onInit(el) {
		this.el = el;

		this.timerPosition = this.el.dataset.timerPosition === 'end';
		this.timerDate = Number(this.el.dataset.timerDate * 1000);
		this.displaySeconds = this.el.dataset.displaySeconds === 'true';
		this.noUnitS = this.el.dataset.noUnitS === 'true';
	}

	onReady() {
		this.countDown();
		this.setHeightAnnouncementBar();
		setInterval(() => {
			this.countDown();
			this.setHeightAnnouncementBar();
		}, 1000);
	}

	setHeightAnnouncementBar() {
		this.announcementBar = document.querySelector('.js-announcement-bar');
		this.heightAnnouncementBar = this.announcementBar.offsetHeight;
		this.root = document.documentElement;
		this.root.style.setProperty(
			'--height-announcement-bar',
			this.heightAnnouncementBar + 'px',
		);
	}

	countDown() {
		// Get now time
		let now = new Date().getTime();
		let timerTarget = new Date(this.timerDate).getTime();
		this.distance = new Date(timerTarget - now);

		// Time calculations for days, hours, minutes and seconds
		let days = Math.floor(this.distance / (1000 * 60 * 60 * 24));
		let hours = Math.floor(
			(this.distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
		);
		let minutes = Math.floor((this.distance % (1000 * 60 * 60)) / (1000 * 60));
		let seconds = Math.floor((this.distance % (1000 * 60)) / 1000);

		// If date is passed, display 0s to avoid negative values
		if (days < 0) {
			days = '0';
		}
		if (hours < 0) {
			hours = '0';
		}
		if (minutes < 0) {
			minutes = '0';
		}
		if (seconds < 0) {
			seconds = '0';
		}

		this.drawTimer(days, hours, minutes, seconds);
	}

	getLabel(value, singular, plural) {
		if (this.noUnitS) {
			return value !== 1 ? plural : singular;
		} else {
			return value > 1 ? plural : singular;
		}
	}

	drawTimer(days, hours, minutes, seconds) {
		const {
			daysString,
			dayString,
			hoursString,
			hourString,
			minutesString,
			minuteString,
			secondsString,
			secondString,
		} = window.timeString.timer;

		// check if we need to display seconds
		let displaySecondswDays = true;
		if (!this.displaySeconds) {
			if (days > 0) {
				displaySecondswDays = false;
			}
		}

		// check if we need to display pluralize -- FR: 0 minute / EN: 0 minutes
		const displayStringDay = this.getLabel(days, dayString, daysString);
		const displayStringHour = this.getLabel(hours, hourString, hoursString);
		const displayStringMin = this.getLabel(
			minutes,
			minuteString,
			minutesString,
		);
		const displayStringSec = this.getLabel(
			seconds,
			secondString,
			secondsString,
		);

		const displayTimer = document.createElement('div');
		displayTimer.id = 'timer';
		displayTimer.classList.add('t-text');
		displayTimer.innerHTML = `
      <span class="timer__item" ${days > 0 ? '' : 'style="display:none"'} >
        <span class="timer__number">${days}</span>
        <span class="timer__label">${displayStringDay}</span>
      </span>
      <span class="timer__item">
        <span class="timer__number">${hours}</span>
        <span class="timer__label">${displayStringHour}</span>
      </span>
      <span class="timer__item">
        <span class="timer__number">${minutes}</span>
        <span class="timer__label">${displayStringMin}</span>
      </span>
      <span class="timer__item" ${
				displaySecondswDays ? '' : 'style="display:none"'
			}>
        <span class="timer__number">${seconds}</span>
        <span class="timer__label">${displayStringSec}</span>
      </span>
    `;

		// check if #timer already exists
		this.elTimer = this.el.querySelector('#timer');
		if (this.elTimer) {
			this.elTimer.innerHTML = displayTimer.innerHTML;
		} else {
			// add the timer before or after text element
			this.timerPosition
				? this.el.append(displayTimer)
				: this.el.prepend(displayTimer, ' ');
		}
	}
}
